import { combineReducers } from 'redux';
import types from './types';
import INITIAL_STATE, { IInitialState } from 'src/store/initialState';
import AddressModel from 'src/model/address.model';

export interface IError {
  hasFailed: boolean;
  message: string;
}

const INITIAL_IS_PENDING = false;
const INITIAL_ERROR: IError = {
  hasFailed: false,
  message: ''
};

const isPending = (
  state: boolean = INITIAL_IS_PENDING,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_IS_PENDING:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const error = (
  state: IError = INITIAL_ERROR,
  {
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_ERROR:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const addresses = (
  state: IInitialState['addresses']['addresses'] = INITIAL_STATE.addresses
    .addresses || [],
  {
    type,
    payload
  }: {
    type: string;
    payload: AddressModel[];
  }
) => {
  switch (type) {
    case types.SET_ADDRESSES: {
      return payload;
    }
    default:
      return state;
  }
};

export default combineReducers({
  addresses,
  isPending,
  error
});
